import React, { Component } from "react";
import colors from "../../colors";
// import menu from "../data/data";//menu
import BudgetTable from "../../BudgetTable";

import Slider from "./Slider";
import MediaQuery from "react-responsive";

const budget = {
  header: [
    "2016-2017",
    "2017-2018",
    "2018-2019",
    "2019-2020",
    "2020-2021",
    "2021-2022",
    "2022-2023",
    "2023-2024",
  ],
  rows: {
    row1: [
      "Satellite Data",
      "0.0",
      "3.0",
      "4.0",
      "4.0",
      "2.0",
      "2.0",
      "1.0",
      "1.0",
      "17.0",
    ],
    row2: [
      "Field Experimentation & OutSoursing Activities",
      "0.0",
      "10.0",
      "45.0",
      "45.0",
      "5.0",
      "5.0",
      "5.0",
      "5.0",
      "120.0",
    ],
    row3: [
      "NRSC Manpower",
      "3.3",
      "3.0",
      "8.4",
      "8.4",
      "8.4",
      "8.4",
      "8.4",
      "8.4",
      "62.4",
    ],
    row4: [
      "Project Scientists",
      "0.0",
      "22.4",
      "22.4",
      "22.4",
      "22.4",
      "22.4",
      "22.4",
      "22.4",
      "157.1",
    ],
    row5: [
      "Data Analysis",
      "0.0",
      "6.0",
      "6.0",
      "6.0",
      "6.0",
      "6.0",
      "6.0",
      "6.0",
      "42.0",
    ],
    row6: [
      "Hardware & Software + Maintenance",
      "13.0",
      "76.0",
      "7.2",
      "7.2",
      "7.2",
      "7.2",
      "7.2",
      "7.2",
      "126.2",
    ],
    row7: [
      "ALT DEM / High Resolution Satellite DEM Generation",
      "0.0",
      "560.0",
      "420.0",
      "4.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "980.0",
    ],
    row8: [
      "Travel & Field Works",
      "1.0",
      "6.0",
      "6.0",
      "6.0",
      "6.0",
      "3.0",
      "3.0",
      "3.0",
      "34.0",
    ],
    row9: [
      "Training & Workshops",
      "0.0",
      "10.0",
      "25.0",
      "10.0",
      "5.0",
      "2.0",
      "2.0",
      "2.0",
      "56.0",
    ],
    row10: [
      "Sub - Total 1",
      "17.3",
      "701.9",
      "537.9",
      "109.1",
      "62.1",
      "56.1",
      "55.1",
      "55.1",
      "1594.6",
    ],
    row11: [
      "Project Management @ 5% of Sub - Total 1",
      "0.9",
      "36.1",
      "26.5",
      "5.5",
      "3.1",
      "2.8",
      "2.8",
      "2.8",
      "79.7",
    ],
    row12: [
      "Sub - Total 2",
      "18.2",
      "737.0",
      "564.8",
      "114.6",
      "65.2",
      "58.9",
      "57.9",
      "57.9",
      "1674.4",
    ],
    row13: [
      "Organization Overheads @ 5% of Sub - Total 2",
      "0.9",
      "36.8",
      "28.2",
      "5.7",
      "3.3",
      "2.9",
      "2.9",
      "2.9",
      "83.7",
    ],
    row14: [
      "Grand Total",
      "19.1",
      "773.8",
      "593.0",
      "120.3",
      "68.5",
      "61.9",
      "60.8",
      "60.8",
      "1758.1",
    ],
  },
};

export default class FLFinancialProposal extends Component {
  render() {
    return (
      <div
        className="ui raised segment"
        style={{
          marginTop: "0em",
          padding: "0px",
          marginLeft: "20%",
          marginRight: "20%",
          height: "800px",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            paddingTop: "0px",
            paddingRight: "10px",
            paddingBottom: "10px",
            paddingLeft: "10px",
            backgroundColor: colors.background,
          }}
        >
          <Slider />
          <div className="card" style={{ flexGrow: "1", overflowX: "auto" }}>
            <MediaQuery minWidth={991}>
              <div
                className="card-body"
                style={{ margin: "auto", padding: "10px" }}
              >
                <h3 align="center" style={{ color: "#002171" }}>
                  Real-time Operational Spatial Flood Early Warning System
                  Development
                </h3>{" "}
                <hr />
                <h5 align="center" style={{ color: "#002171" }}>
                  Financial Proposal
                </h5>
                <BudgetTable data={budget} />
                {/* <img class="card-img-top" height="400" width="800" src={this.props.budget}/> */}
              </div>
            </MediaQuery>
            <MediaQuery maxWidth={991}>
              <div className="card-body" style={{ padding: "10px" }}>
                <h3 align="center" style={{ color: "#002171" }}>
                  Real-time Operational Spatial Flood Early Warning System
                  Development
                </h3>{" "}
                <hr />
                <h5 align="center" style={{ color: "#002171" }}>
                  Financial Proposal
                </h5>
                <BudgetTable data={budget} />
                {/* <img class="card-img-top" height="400" width="800" src={this.props.budget}/> */}
              </div>
            </MediaQuery>
          </div>
        </div>
      </div>
    );
  }
}
